// extracted by mini-css-extract-plugin
export default {"animate-wave":"AudioPlayer_animate-wave__81q4D","wave-animation":"AudioPlayer_wave-animation__r17VH","wave-bar":"AudioPlayer_wave-bar__mYBG4"};